module.exports = __webpack_public_path__ + "img/item_Story_28.7e13c179.jpeg";